import {
  ACTIVITY_SUMMARY,
  ACTIVITY_SUMMARY_ERROR,
  ACTIVITY_SUMMARY_SUCCESS,
  EXCLUDE_SCREEN,
  EXCLUDE_SCREEN_ERROR,
  EXCLUDE_SCREEN_LOGS,
  EXCLUDE_SCREEN_LOGS_ERROR,
  EXCLUDE_SCREEN_LOGS_SUCCESS,
  EXCLUDE_SCREEN_SUCCESS,
  PROJECT_LIST,
  PROJECT_LIST_ERROR,
  PROJECT_LIST_SUCCESS,
  SCREEN_VERIFIED,
  SCREEN_VERIFIED_ERROR,
  SCREEN_VERIFIED_SUCCESS,
  TEAM_GET_SCREEN_LOGS,
  TEAM_GET_SCREEN_LOGS_ERROR,
  TEAM_GET_SCREEN_LOGS_SUCCESS,
  TIMESHEET_USER,
  TIMESHEET_USER_ERROR,
  TIMESHEET_USER_SUCCESS,
  FILTERED_SCREEN_IMAGES,
  GET_PROJECT_SUMMARY_REPORT_SCREEN,
  GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS,
  GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR,
  GET_PROJECT_SUMMARY_WORK_REPORTS,
  GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS,
  GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR
} from "./actionTypes"

export const getUserTimeSheetReport = timesheet => {
  return {
    type: TIMESHEET_USER,
    payload: { timesheet },
  }
}

export const getUserTimeSheetReportSuccess = timesheet => {
  return {
    type: TIMESHEET_USER_SUCCESS,
    payload: timesheet,
  }
}

export const getUserTimeSheetReportError = timesheet => {
  return {
    type: TIMESHEET_USER_ERROR,
    payload: timesheet,
  }
}

export const getallprojectlist = projectlist => {
  return {
    type: PROJECT_LIST,
    payload: { projectlist },
  }
}

export const getallprojectListSuccess = projectlist => {
  return {
    type: PROJECT_LIST_SUCCESS,
    payload: projectlist,
  }
}

export const getallprojectListError = projectlist => {
  return {
    type: PROJECT_LIST_ERROR,
    payload: projectlist,
  }
}

export const screenVerified = (screens, callback) => {
  return {
    type: SCREEN_VERIFIED,
    payload: { screens },
    callback
  }
}

export const screenVerifiedSuccess = screens => {
  return {
    type: SCREEN_VERIFIED_SUCCESS,
    payload: screens,
  }
}

export const screenVerifiedError = screens => {
  return {
    type: SCREEN_VERIFIED_ERROR,
    payload: screens,
  }
}

export const getActivitySummary = activity => {
  return {
    type: ACTIVITY_SUMMARY,
    payload: activity,
  }
}

export const getActivitySummarySuccess = activity => {
  return {
    type: ACTIVITY_SUMMARY_SUCCESS,
    payload: activity,
  }
}

export const getActivitySummaryError = activity => {
  return {
    type: ACTIVITY_SUMMARY_ERROR,
    payload: activity,
  }
}

//Screen
// add new Profile
export const onExcludeScreen = (exclude, callback) => ({
  type: EXCLUDE_SCREEN,
  payload: exclude,
  callback,
})

export const excludeScreenSuccess = exclude => ({
  type: EXCLUDE_SCREEN_SUCCESS,
  payload: exclude,
})

export const excludeScreenFail = error => ({
  type: EXCLUDE_SCREEN_ERROR,
  payload: error,
})

// exclude screen logs
export const onExcludeScreenlogs = (excludelogs, callback) => ({
  type: EXCLUDE_SCREEN_LOGS,
  payload: excludelogs,
  callback,
})

export const excludeScreenlogsSuccess = excludelogs => ({
  type: EXCLUDE_SCREEN_LOGS_SUCCESS,
  payload: excludelogs,
})

export const excludeScreenlogsFail = error => ({
  type: EXCLUDE_SCREEN_LOGS_ERROR,
  payload: error,
})
// Team Based screen logs
export const onteamScreenlogs = (teamslogs, callback) => ({
  type: TEAM_GET_SCREEN_LOGS,
  payload: teamslogs,
  callback,
})

export const teamScreenlogsSuccess = teamslogs => ({
  type: TEAM_GET_SCREEN_LOGS_SUCCESS,
  payload: teamslogs,
})

export const teamScreenlogsFail = error => ({
  type: TEAM_GET_SCREEN_LOGS_ERROR,
  payload: error,
})

export const filteredScreenImages = data => ({
  type: FILTERED_SCREEN_IMAGES,
  payload: data,
})
// verify screen  screen logs hoursReport
export const getprojectsummaryreportscreens = (screens, callback) => ({
  type: GET_PROJECT_SUMMARY_REPORT_SCREEN,
  payload: screens,
  callback,
})

export const getprojectsummaryreportscreensSuccess = screens => ({
  type: GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS,
  payload: screens,
})

export const getprojectsummaryreportscreensFail = error => ({
  type: GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR,
  payload: error,
})
// verify screen  report logs hoursReport
export const getprojectsummaryreport = (screens, callback) => ({
  type: GET_PROJECT_SUMMARY_WORK_REPORTS,
  payload: screens,
  callback,
})

export const getprojectsummaryreportSuccess = screens => ({
  type: GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS,
  payload: screens,
})

export const getprojectsummaryreportFail = error => ({
  type: GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR,
  payload: error,
})
